import { TableStyle } from "../../../models/components/table/table.model";
import UiTable from "../../../components/table/Table.component";
import { TableColumnTemplate } from "../../../models/components/table/table-column.model";
import { TablePagination } from "../../../models/components/table/table-pagination.model";
import { StoredCriteriaService } from "../../../services/session/stored-criteria.service";
import { useState, useEffect, useContext } from "react";
import { ChecklistResponse } from "../../../models/endpoints/checklists-endpoint.model";
import { ChecklistRow } from "../../../models/pages/checklists/checklists-list.model";
import ChecklistsNestedList from "./ChecklistsNestedList";
import { ParticipantContext } from "../../../contexts/Participant.context";
import { ParticipantContextProps } from "../../../models/contexts/participant-context.model";
import { useUpdateChecklistOverride } from "./useUpdateChecklist";

const ChecklistsList = ({ checklists }: { checklists: ChecklistResponse[] | undefined }) => {
	// Pagination
	const [pagination, _setPagination] = useState<TablePagination>(
		StoredCriteriaService.getPagination(StoredCriteriaService.KEYS["checklists"]) ?? {
			first: 0,
			rows: 20,
			page: 0,
			sortField: undefined,
			sortOrder: undefined,
			search: undefined,
			filters: undefined,
		}
	);

	const mapToChecklistRow = (checklist: ChecklistResponse) => {
		return {
			id: checklist.id,
			name: checklist.name,
			description: checklist.description,
			applicable: checklist.applicable,
			completed: checklist.completed,
			items: checklist.items?.map((item) => ({
				id: item.id,
				name: item.name,
				description: item.description,
				completed: item.completed,
				applicable: item.applicable,
			})),
		};
	};

	const [rows, setRows] = useState<ChecklistRow[]>([]);
	const updateChecklist = useUpdateChecklistOverride();
	const participantContext = useContext<ParticipantContextProps>(ParticipantContext);

	useEffect(() => {
		setRows(checklists?.map((checklist) => mapToChecklistRow(checklist)) || []);
	}, [checklists]);

	return (
		<UiTable
			dataKey="id"
			type={TableStyle.GREEN}
			tableClassName="nested-table"
			useAsCard={false}
			pagination={pagination}
			paginator={false}
			rowClassName={() => "inline-form"}
			value={rows}
			expandedTemplate={(rowData: ChecklistRow) => (
				<ChecklistsNestedList
					rows={rowData.items}
					checklistId={rowData.id}
				/>
			)}
			columns={[
				{
					field: "name",
					title: "PARTICIPANT.CHECKLISTS.LIST.COLUMNS.NAME",
					sortable: false,
					template: TableColumnTemplate.TRANSLATE,
				},
				{
					field: "completed",
					title: "PARTICIPANT.CHECKLISTS.LIST.COLUMNS.COMPLETED",
					sortable: false,
					template: TableColumnTemplate.BOOLEAN,
					isReadOnly: true,
					style: {
						width: "30px",
						textAlign: "center",
						alignContent: "center",
					},
				},
				{
					field: "applicable",
					title: "PARTICIPANT.CHECKLISTS.LIST.COLUMNS.APPLICABLE",
					sortable: false,
					template: TableColumnTemplate.BOOLEAN,
					style: {
						width: "30px",
						textAlign: "center",
						alignContent: "center",
					},
					onChange(event, rowData) {
						updateChecklist.mutateAsync({
							checkListId: rowData.id,
							patientId: participantContext.participant!.id,
							applicable: event.target.value,
						});
					},
				},
				{
					field: "expandCollapse",
					template: TableColumnTemplate.EXPANDER,
					style: {
						textAlign: "right",
						paddingRight: "2rem",
						width: "150px",
					},
				},
			]}
		/>
	);
};
export default ChecklistsList;
